
import { DocumentCard } from "./DocumentCard";
import { Database } from "@/integrations/supabase/types";

type Document = Database["public"]["Tables"]["documents"]["Row"];

interface DocumentLibraryProps {
  documents: Document[];
  onNavigate: (id: string) => void;
  onDownload: (doc: Document) => void;
  onDelete: (id: string) => void;
  downloadingId: string | null;
}

export function DocumentLibrary({ 
  documents, 
  onNavigate, 
  onDownload, 
  onDelete, 
  downloadingId 
}: DocumentLibraryProps) {
  if (documents.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="max-w-md mx-auto">
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            No documents yet
          </h3>
          <p className="text-gray-600 mb-4">
            Create your first document to get started with CSO Agent.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {documents.map((doc) => (
        <DocumentCard
          key={doc.id}
          doc={doc}
          onNavigate={onNavigate}
          onDownload={onDownload}
          onDelete={onDelete}
          downloadingId={downloadingId}
        />
      ))}
    </div>
  );
}
